/**
 * Created by meirr on 9/22/16.
 */
define(function (require) {

    var _ = require('underscore');
    var lpUtils = require('utils/lpUtils');
    var BaseFilterItem = require('web-agent-components/BaseFilterItemViewController');
    var NumericInputViewController = require('web-agent-viewControllers/NumericInputViewController');
    var ButtonDropdownViewController = require('web-agent-components/ButtonDropdownViewController');

    var FilterItemNumericRange = BaseFilterItem.extend({

        LPElementsMap: {

        },
        LPTemplatesFiles: {
            numericRangeItem: 'LP_filter_full_table_numeric_range.html'
        },
        LPClassesMap: {
            startInput: ".start",
            endInput: ".end",
            units: ".units",
            tableContainer: ".list_table_container"
        },

        initialize: function (constructorData) {
            var numericTemplate = require('web-agent-templates/' + this.LPTemplatesFiles.numericRangeItem);
            // var numericTemplate = lpUtils.loadResource(this.LPTemplatesFiles.numericRangeItem);
            this.view  = this.createView({template: numericTemplate});
            this.defaultFilterUIData = lpUtils.cloneObject(constructorData.defaultFilter || {});
            this.filterUIData = lpUtils.cloneObject(constructorData.defaultFilter || {});
            this.units = constructorData.units;
            this.config = constructorData;
        },
        events: function () {
        },
        render: function () {

            this.startValueVC = new NumericInputViewController({
                defaultInputValue: this.filterUIData.start,
                minimumInputValue: this.config.startMinValue,
                maximumInputValue: this.config.startMaxValue,
                valueChangedCallback: this._onValueChanged.bind(this, 'start'),
                lostFocusCallback: this._onFocusChanged.bind(this, 'start'),
                context: this
            });
            this.addViewController({viewController: this.startValueVC, target: this.LPClassesMap.startInput});

            this.endValueVC = new NumericInputViewController({
                defaultInputValue: this.filterUIData.end,
                minimumInputValue: this.config.endMinValue,
                maximumInputValue: this.config.endMaxValue,
                valueChangedCallback: this._onValueChanged.bind(this, 'end'),
                lostFocusCallback: this._onFocusChanged.bind(this, 'end'),
                context: this
            });

            this.addViewController({viewController: this.endValueVC, target: this.LPClassesMap.endInput});

            if(this.units && this.units.length) {
                this.unitsVC = new ButtonDropdownViewController({
                    items: this.units,
                    selectedIndex: 0,
                    context: this,
                    itemClicked: this._onUnitChanged,
                    textProperty: "text",
                    scrollableContainer: this.LPClassesMap.tableContainer
                });
                this.selectedUnit = this.units[0].type;
                this.addViewController({viewController: this.unitsVC, target: this.LPClassesMap.units});
            }
        }
    });

    /**
     * @override
     */
    FilterItemNumericRange.prototype.getValue = function() {

        if(!this.filterUIData.start && !this.filterUIData.end){
           return undefined;
        }

        return {
            start: _.isUndefined(this.filterUIData.start) ? this.defaultFilterUIData.start : this.filterUIData.start,
            end: _.isUndefined(this.filterUIData.end) ? this.defaultFilterUIData.end : this.filterUIData.end,
            unit: this.selectedUnit
        };
    };

    /**
     * @override
     */
    FilterItemNumericRange.prototype.updateFilterUI = function (filterUIData) {
        this.filterUIData = lpUtils.cloneObject(filterUIData || this.defaultFilterUIData);

        if(_.isNumber(this.filterUIData.start)) {
            this.startValueVC.setCurrentInputValue(this.filterUIData.start);
        } else {
            this.startValueVC.setCurrentValue("");
        }

        if(_.isNumber(this.filterUIData.end)) {
            this.endValueVC.setCurrentInputValue(this.filterUIData.end);
        } else {
            this.endValueVC.setCurrentValue("");
        }
    };

    /**
     * Callback for numeric field value change
     * @param {String} target start or end fields
     * @param {String} value
     * @private
     */
    FilterItemNumericRange.prototype._onValueChanged = function(target, value) {
        this.filterUIData[target] = value;
        this._validate();
    };

    /**
     * Callback for numeric field focus change
     * @param {String} target start or end fields
     * @param {String} value
     * @private
     */
    FilterItemNumericRange.prototype._onFocusChanged = function(target, event) {
        if(event.target.value === "") {
            this.filterUIData[target] = undefined;
        }
    };

    /**
     * Validates that start in lower then end and updates end accordingly
     * @private
     */
    FilterItemNumericRange.prototype._validate = function() {
        if(_.isNumber(this.filterUIData.start) && _.isNumber(this.filterUIData.end)) {
            if(this.filterUIData.end < this.filterUIData.start) {
                this.filterUIData.end = this.filterUIData.start;
                this.updateFilterUI(this.filterUIData);
            }
        }
    };

    /**
     * Callback for unit dropdown change
     * @param {Object} unitItem
     * @private
     */
    FilterItemNumericRange.prototype._onUnitChanged = function(unitItem) {
        this.selectedUnit = unitItem.rowData.type;
    };


    return FilterItemNumericRange;

});
